@import "../../global/normalize.css";

/**
 * @prop --ic-z-index-back-to-top: z-index of back to top
 * @prop --margin-right: right y-position of back to top
 * @prop --margin-left: left y-position of back to top
 * @prop --footer-offset: offset of x-position from footer
 */

:host {
  display: flex;
  flex: row;
  height: 0.1px;
}

:host(.ic-back-to-top-right) {
  justify-content: flex-end;
}

:host(.ic-back-to-top-right) ic-button {
  margin-right: var(--margin-right, 1rem);
}

:host(.ic-back-to-top-right) .ic-back-to-top-icon {
  padding-top: var(--ic-space-xxs);
  padding-right: var(--ic-space-xs);
}

:host(.ic-back-to-top-left) {
  justify-content: flex-start;
}

:host(.ic-back-to-top-left) ic-button {
  margin-left: var(--margin-left, 1rem);
}

:host(.ic-back-to-top-left) .ic-back-to-top-icon {
  padding-top: var(--ic-space-xxs);
  padding-right: var(--ic-space-xs);
}

:host(.ic-back-to-top-center) {
  justify-content: center;
}

:host(.ic-back-to-top-center) .ic-back-to-top-icon {
  padding-top: var(--ic-space-xxs);
  padding-right: var(--ic-space-xs);
}

ic-button {
  height: 2.5rem;
  align-items: center;
  background-color: var(--ic-color-background-primary);
  border-radius: 5rem;
  box-shadow: var(--ic-elevation-overlay);
  visibility: hidden;
  position: fixed;
  bottom: var(--ic-space-md);
  opacity: 0;
  transition: visibility 0s linear var(--ic-transition-duration-slow),
    opacity var(--ic-transition-duration-slow);
  z-index: var(--ic-z-index-back-to-top);
}

:host(.ic-back-to-top-variant-icon) ic-button::part(button) {
  margin: 0;
}

ic-button::part(button) {
  border-radius: 5rem;
}

ic-button.show {
  visibility: visible;
  opacity: 1;
  transition: visibility 0s linear 0s,
    opacity var(--ic-transition-duration-slow),
    box-shadow var(--ic-easing-transition-fast);
}

ic-button.offset-banner:not(.by-footer) {
  margin-bottom: var(--footer-offset, var(--ic-space-lg));
}

.ic-back-to-top-icon > svg {
  height: var(--ic-space-md);
  width: var(--ic-space-md);
}

.icon-only {
  width: 2.5rem;
}

.icon-only .ic-back-to-top-icon > svg {
  padding-left: calc(var(--ic-space-xs) - var(--ic-space-1px));
}

ic-button.by-footer {
  position: relative;
  bottom: var(--footer-offset, 3.5rem);
}

@media (forced-colors: active) {
  .icon-only .ic-back-to-top-icon > svg {
    padding-left: calc(var(--ic-space-xs) - var(--ic-space-xxxs));
  }
}

@media (prefers-reduced-motion: reduce) {
  ic-button,
  ic-button.show {
    transition: none;
  }
}
